import React from 'react';
import { Button, Typography, Modal } from 'antd';
import { useStateMethods } from '../../../providers/stateManager';
import { stateKeys } from '../../../constants/stateKeys';
import { useLoading } from '../providers';
import styles from './index.module.scss';

const EditHeader = () => {
  return (
    <div className={styles.root}>
      <Typography.Text className={styles.title}>
        Редактирование комментария
      </Typography.Text>

      <Cancel />
    </div>
  );
};

export default EditHeader;

function Cancel() {
  const { setState } = useStateMethods();

  const loading = useLoading();

  if (loading) return null;

  const handleClick = () => {
    Modal.confirm({
      title: 'Вы уверены, что хотите прекратить редактирование?',
      centered: true,
      onOk() {
        setState((prev) => {
          const prevImages = prev[stateKeys.images];
          const prevFiles = prev[stateKeys.files];

          return {
            ...prev,
            [stateKeys.editComment]: undefined,
            [stateKeys.text]: '',
            [stateKeys.files]: prevFiles.length ? [] : prevFiles,
            [stateKeys.images]: prevImages.length ? [] : prevImages,
          };
        });
      },
      okText: 'Да',
      cancelText: 'Нет',
      onCancel() {},
    });
  };

  return (
    <Button
      className={styles.cancel}
      style={{ border: 'none' }}
      icon={'close'}
      size="large"
      onClick={handleClick}
    />
  );
}
